import React from 'react';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-292">
      <Navigation data-id="element-293" />

      <main data-id="element-294">
        <Hero data-id="element-295" />
        <WhyUs data-id="element-296" />
        <Services data-id="element-297" />
        <FAQ data-id="element-298" />
        <Testimonials data-id="element-299" />
        <Consultation data-id="element-300" />
      </main>

      <Footer data-id="element-301" />
      <CookieBanner data-id="element-302" />
    </div>;
}